"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var IconBase_1 = __importDefault(require("../IconBase"));
var util_1 = require("../util");
var User = function (props) {
    var _a = (0, util_1.getVariantClassNames)(props), primary = _a.primary, secondary = _a.secondary;
    return (react_1.default.createElement(IconBase_1.default, __assign({}, props),
        react_1.default.createElement("path", { d: "M20 18.3333C16.3333 18.3333 13.3333 15.3333 13.3333 11.6667C13.3333 8 16.3333 5 20 5C23.6667 5 26.6667 8 26.6667 11.6667C26.6667 15.3333 23.6667 18.3333 20 18.3333Z", className: secondary }),
        react_1.default.createElement("path", { d: "M5 33.6667C5.66667 25.75 12.0833 21.6667 20 21.6667C28 21.6667 34.5 25.5 35 33.6667C35 34 35 35 33.75 35C27.5833 35 18.4167 35 6.25 35C5.83333 35 5 34.0834 5 33.6667Z", className: primary })));
};
exports.default = User;
